// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NFDhnNP_qhUbWXy6uWaD {
    align-items: center;
    column-gap: 10px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.VcdM3SEro3DHBl2UtUsp {
    display: flex;
    flex-direction: row;
    column-gap: 10px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.oR1SHanxj5BRy4NXm2hD {
    display: block;

    @media (max-width: 980px) {
        display: none;
    }
}


.x6csmIuHo_Zl9Z9jLzgZ {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-self: flex-end;
    width: 0.75rem;
}

.AMNfzAzdW2THyCl47DHt path {
    fill: #FFFFFF;
}

.GmtPMdMnagtnmvnoq4sj path {
    fill: #BB1907;
}

.ExCFytiNCjb0oYl7vEyH path {
    fill: #00A02A;
}

.GmtPMdMnagtnmvnoq4sj {
    width: 0.75rem;
    height: 0.75rem;
}

.rbH9IIFyKKUaY1M2BjWV {
    opacity: 0.7;
    cursor: text;
}

.XH0pOMF9JbrbQvjnmFBk {
    display: flex;
    flex-direction: row;
    column-gap: 1rem;
    place-content: flex-end;
}

.FicOAh1kJIhezm7A2o8N {
    width: 1.25rem;
    height: 1.25rem;
}

.ekeJpt_uaUFaUFrjR4Il {
    font-weight: 800 !important;
}

.Y5ziMLl_25DuUUze25Kr {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.UgnSi6GFOy4nnLj5hCdq {
    font-weight: 800;
    text-transform: capitalize;
}

.dMKQLh2igPZyNS_wQsJx {
    display: flex;
    column-gap: 0.25rem;
    justify-content: flex-end;
    cursor: pointer;
    text-decoration: none;
}

.dMKQLh2igPZyNS_wQsJx path {
    fill: #BB1907;
}

.c7gyhZO_EObEptwnS17U {
    width: 0.75rem;
    height: 0.75rem;
}

.SJC77FAwCGZQxViwTF9w {
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
}

.gpucbfqx4CLSOYNlg2M0 {
    display: flex;
    column-gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/components/AccessibilityChecker/AccessibilityChecker.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;;IAEd;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".header-title {\n    align-items: center;\n    column-gap: 10px;\n    display: flex;\n    flex-direction: row;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.header-button {\n    display: flex;\n    flex-direction: row;\n    column-gap: 10px;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.header-button-text {\n    display: block;\n\n    @media (max-width: 980px) {\n        display: none;\n    }\n}\n\n\n.header-close {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-self: flex-end;\n    width: 0.75rem;\n}\n\n.icon path {\n    fill: #FFFFFF;\n}\n\n.header-icon path {\n    fill: #BB1907;\n}\n\n.header-icon-success path {\n    fill: #00A02A;\n}\n\n.header-icon {\n    width: 0.75rem;\n    height: 0.75rem;\n}\n\n.inactive {\n    opacity: 0.7;\n    cursor: text;\n}\n\n.actions {\n    display: flex;\n    flex-direction: row;\n    column-gap: 1rem;\n    place-content: flex-end;\n}\n\n.title-icon {\n    width: 1.25rem;\n    height: 1.25rem;\n}\n\n.body-title {\n    font-weight: 800 !important;\n}\n\n.body-info-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.body-info-level {\n    font-weight: 800;\n    text-transform: capitalize;\n}\n\n.body-info-link-container {\n    display: flex;\n    column-gap: 0.25rem;\n    justify-content: flex-end;\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.body-info-link-container path {\n    fill: #BB1907;\n}\n\n.link-icon {\n    width: 0.75rem;\n    height: 0.75rem;\n}\n\n.impact-circle {\n    width: 1rem;\n    height: 1rem;\n    border-radius: 1rem;\n}\n\n.impact-text {\n    display: flex;\n    column-gap: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header-title": `NFDhnNP_qhUbWXy6uWaD`,
	"header-button": `VcdM3SEro3DHBl2UtUsp`,
	"header-button-text": `oR1SHanxj5BRy4NXm2hD`,
	"header-close": `x6csmIuHo_Zl9Z9jLzgZ`,
	"icon": `AMNfzAzdW2THyCl47DHt`,
	"header-icon": `GmtPMdMnagtnmvnoq4sj`,
	"header-icon-success": `ExCFytiNCjb0oYl7vEyH`,
	"inactive": `rbH9IIFyKKUaY1M2BjWV`,
	"actions": `XH0pOMF9JbrbQvjnmFBk`,
	"title-icon": `FicOAh1kJIhezm7A2o8N`,
	"body-title": `ekeJpt_uaUFaUFrjR4Il`,
	"body-info-container": `Y5ziMLl_25DuUUze25Kr`,
	"body-info-level": `UgnSi6GFOy4nnLj5hCdq`,
	"body-info-link-container": `dMKQLh2igPZyNS_wQsJx`,
	"link-icon": `c7gyhZO_EObEptwnS17U`,
	"impact-circle": `SJC77FAwCGZQxViwTF9w`,
	"impact-text": `gpucbfqx4CLSOYNlg2M0`
};
export default ___CSS_LOADER_EXPORT___;
